import { DrawLineStringMode, ModifyMode } from "@deck.gl-community/editable-layers";
import { UrbanFeature, UrbanFeatureMode, UrbanFeatureModeType } from "./urban-feature.types";
import { UrbanFeatureType } from "@/types/gql/graphql";

export const initUrbanFeature: UrbanFeature = {
  name: "",
  geometry: {
    type: "Point",
    coordinates: [],
  },
  address: {
    streetNumber: "",
    streetName: "",
    city: "",
    postalCode: "",
    country: "",
  },
  cityId: "",
  type: UrbanFeatureType.TrafficLight,
};

export const ICON_MAPPING = {
  marker: { x: 0, y: 0, width: 60, height: 226 },
};

export enum UrbanFeatureModalState {
  SHOW = "SHOW",
  DEACTIVATE = "DEACTIVATE",
  MINIMIZE = "MINIMIZE",
}

export const cursorCell: UrbanFeatureMode[] = [
  UrbanFeatureModeType.AddTrafficLight,
  UrbanFeatureModeType.AddCrosswalk,
  UrbanFeatureModeType.AddSpeedBump,
];
export const crosswalkModes = [UrbanFeatureModeType.AddCrosswalk, UrbanFeatureModeType.EditCrosswalk];
export const speedBumpModes = [UrbanFeatureModeType.AddSpeedBump, UrbanFeatureModeType.EditSpeedBump];
export const urbanFeaturePolygonModes = [...crosswalkModes, ...speedBumpModes];
export const urbanFeaturePolygonAddModes = [UrbanFeatureModeType.AddCrosswalk, UrbanFeatureModeType.AddSpeedBump];
export const urbanFeaturePolygonEditModes = [UrbanFeatureModeType.EditCrosswalk, UrbanFeatureModeType.EditSpeedBump];

export const urbanFeatureValue: Record<UrbanFeatureType, string> = {
  [UrbanFeatureType.TrafficLight]: "Traffic light",
  [UrbanFeatureType.Crosswalk]: "Crosswalk",
  [UrbanFeatureType.SpeedBump]: "Speed bump",
};

/** Different GeoJsonEditModes of polygon layer depending on app mode */
export const urbanFeaturePolygonEditorLayerModes = {
  [UrbanFeatureModeType.AddCrosswalk]: DrawLineStringMode,
  [UrbanFeatureModeType.EditCrosswalk]: ModifyMode,
  [UrbanFeatureModeType.AddSpeedBump]: DrawLineStringMode,
  [UrbanFeatureModeType.EditSpeedBump]: ModifyMode,
};
